import React, { useState, useEffect } from "react";
import notificationsImage from "../assets/images/navbar_icons/notifications.svg";
import { get, post } from "../server";
import {
  USER_NOTIFICATION,
  DELETE_USER_NOTIFICATION,
} from "../utils/constants/apiUrl";
import { loggedInUser } from "../utils/store";
import { useAtom } from "jotai";
import showToast from "../helpers/showToast";
// import { formatDate } from "../utils/functions";
import { Link } from "react-router-dom";
import ConfirmationModal from "./Modals/ConfirmationModal";

const AllNotifications = ({ showNotification, setShowNotification }) => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [loggedUser] = useAtom(loggedInUser);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    const handler = () => setShowNotification(false);

    window.addEventListener("click", handler);

    return () => {
      window.removeEventListener("click", handler);
    };
  });

  useEffect(() => {
    loadNotification();
  }, []);

  // ../utils/functions.js

  const formatDate = (date) => {
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    const formattedDate = date.toLocaleString("en-US", options);
    return formattedDate.replace(/\//g, "-");
  };

  const loadNotification = async () => {
    let { status, data, message } = await get(
      USER_NOTIFICATION,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      if (Object.keys(data).length > 0) setNotifications(data);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };
  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = () => {
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    //handleCloseConfirmationModal(true);
    //setLoading(true);
    // const queryString = `?coupon_id=${deleteId}`;
    // const queryString = `?id=${couponId}`;
    let { status, message } = await post(
      DELETE_USER_NOTIFICATION,
      {},
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadNotification();
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      <div
        className="notificationsMainWrapper"
        onBlur={() => setShowNotification(false)}
      >
        <div className="notificationHeader">
          <p className="title">Notifications</p>
          {notifications.length > 0 ? (
            <Link onClick={handleConfirmDelete}>
              <button className="clearBtn">Clear</button>
            </Link>
          ) : (
            ""
          )}
        </div>
        {loading ? (
          // Loader divs
          <div className="loaderWrapper">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            {notifications.length > 0 ? (
              <>
                {notifications.map((notification) => {
                  return (
                    <div
                      className="notiContentWrapper"
                      onClick={(e) => e.stopPropagation()}
                      key={notification.id}
                    >
                      <p className="date">
                        {formatDate(new Date(notification.created_at))}
                      </p>
                      <div className="notificationsWrapper">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-2">
                            <img src={notificationsImage} alt="" />
                            <h6 className="notificationTitle">
                              {notification.title}
                            </h6>
                          </div>
                        </div>
                        <p className="notificationDetail">
                          {notification.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="noRecordFound">
                <p>No Notifications Found </p>
              </div>
            )}
          </>
        )}
      </div>
      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="Notification"
      />
    </>
  );
};

export default AllNotifications;
